// extracted by mini-css-extract-plugin
module.exports = {"label":"ScatterTooltip_label__2wU6a","value":"ScatterTooltip_value__1K7gi","wrapper":"ScatterTooltip_wrapper__2MhtB"};